<template>
  <div>
    <!-- mobile absence registration form -->
    <div class="is-hidden-tablet">
        <div class="field is-horizontal">
            <div class="field-label is-normal">
            <label class="label">{{$t("absence.absence")}}</label>
            </div>
            <div class="field-body">
            <div class="field is-narrow">
                <div class="control">
                    <AbsenceSelect 
                        @absence="setAbsence"
                        :absence-codes="absenceCodes"
                        :custom-absence="orgSettings.customAbsence"
                        :use-custom-absence="!orgSettings.ERPenabled"
                    ></AbsenceSelect>
                </div>
            </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-body">
            <div class="columns is-mobile">
                <div class="column">
                <div class="field-label is-normal">
                <label class="label">{{$t("absence.from")}}</label>
                </div>
                <div class="field is-grouped">
                    <div class="control">
                        <Datepicker
                            v-model="fromDate"
                            :language="da" 
                            class="input"
                            input-class="date-picker"
                            format="dd/MM/yy"
                            :monday-first="true"
                        ></Datepicker>
                    </div>
                </div>
                </div>
                <div class="column">
                <div class="field-label is-normal">
                    <label class="label">{{$t("absence.to")}}</label>
                </div>
                <div class="field is-grouped">
                    <div class="control">
                        <Datepicker
                            v-model="toDate"
                            :language="da" 
                            class="input"
                            input-class="date-picker"
                            format="dd/MM/yy"
                            :monday-first="true"
                        ></Datepicker>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        <div class="field-label is-normal">
            <label class="label">{{$t("absence.time")}}</label>
        </div>
        <div class="field-body">
            <div class="field is-narrow">
            <div class="control">
                <input v-model.number="time" class="input" type="number" min=0 max=100 step="0.5">
            </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label">
            <!-- Left empty for spacing -->
            </div>
            <div class="field-body">
            <div class="field">
                <div class="control">
                <button v-on:click="addRegistration" class="button is-primary">{{$t("input.save")}}</button>
                </div>
            </div>
            </div>
        </div>
        <!-- mobile absence table -->
        <table class="table is-narrow">
            <tfoot>
            <tr>
                <th></th>
                <th>
                    <input @click="sendAbsenceForApproval(absenceNotSentForApproval)" type="button" :value="$t('input.sendForApp')" class="button is-primary is-small">
                </th>
                <th></th>
                <th></th>
                <th>{{ totalTime }}</th>
                <th></th>
            </tr>
            </tfoot>
            <tbody>
            <tr v-if="value.sentForApproval == false" v-for="(value, key) in absenceNotSentForApproval" v-bind:key="key">
                <th>{{ key+1 }}</th>
                <td>{{ value.absence }} ({{ value.absenceMeasure }})</td>
                <td>{{ value.fromDate }}</td>
                <td>{{ value.toDate }}</td>
                <td>{{ value.time }}</td>
                <td><a v-on:click="removeRegistration(value)" class="delete"></a></td>
                </tr>
            </tbody>
            </table>
        </div>
        <table class="table is-hidden-mobile is-fullwidth">
            <thead>
                <tr>
                <th><abbr title="Nummer">Nr.</abbr></th>
                <th>{{$t("absence.absence")}}</th>
                <th>{{$t("absence.from")}}</th>
                <th>{{$t("absence.to")}}</th>
                <th>{{$t("absence.time")}}</th>
                <th>{{$t("settings.approval")}}</th>
                <th>{{$t("settings.save_delete")}}</th>
                </tr>
            </thead>
            <tfoot>
                <tr>
                <th></th>
                <th>
                   <input @click="sendAbsenceForApproval(absenceNotSentForApproval)" type="button" :value="$t('input.sendForApp')" class="button is-primary is-small" :disabled="totalTime == 0">
                </th>
                <th></th>
                <th></th>
                <th>{{ totalTime }}</th>
                <th></th>
                <th></th>
                </tr>
            </tfoot>
            <tbody>
                <tr v-if="value.sentForApproval == false" v-for="(value, key) in absenceNotSentForApproval" v-bind:key="key">
                    <th>{{ key+1 }}</th>
                    <td>{{ value.absence }} ({{ value.absenceMeasure }})</td>
                    <td>{{ value.fromDate }}</td>
                    <td>{{ value.toDate }}</td>
                    <td>{{ value.time }}</td>
                    <td>
                    <span class="tag is-warning" v-if="value.isRejected">Afvist</span>
                    </td>
                    <td><a v-on:click="removeRegistration(value)" class="delete"></a></td>
                </tr>
                <tr>
                    <th>Ny</th>
                    <td>
                        <AbsenceSelect 
                            @absence="setAbsence"
                            :absence-codes="absenceCodes"
                            :custom-absence="orgSettings.customAbsence"
                            :use-custom-absence="!orgSettings.ERPenabled"
                        ></AbsenceSelect>
                    </td>
                    <td>
                    <p class="control">
                        <Datepicker
                            v-model="fromDate"
                            :language="da" 
                            class="input"
                            input-class="date-picker"
                            format="dd/MM/yy"
                            :monday-first="true"
                        ></Datepicker>
                    </p>
                    </td>
                    <td>
                    <p class="control">
                        <Datepicker
                            v-model="toDate"
                            :language="da" 
                            class="input"
                            input-class="date-picker"
                            format="dd/MM/yy"
                            :monday-first="true"
                        ></Datepicker>
                    </p>
                    </td>
                    <td>
                        <p class="control">
                            <input v-model.number="time" class="input absence-input" type="number" :disabled="!allowEdit">
                            <span class="help"><a @click="allowEdit = !allowEdit">{{$t('input.edit')}}</a></span>
                            <a @click="timeInfoIsClicked = !timeInfoIsClicked">
                                <span v-if="showTimeInfo" class="tag is-light" style="position: absolute; right: 4px; top: 5px;">i</span>
                            </a>
                            <span v-show="timeInfoIsClicked">
                                <small>{{$t("absence.noDaysCalcText")}}</small>
                            </span>
                        </p>
                    </td>
                    <td></td>
                    <td>
                    <p class="control">
                        <input v-if="time <= 0" type="submit" :value="$t('input.error')" class="button is-danger is-small is-outlined" :disabled="time <= 0">
                        <input v-if="time > 0" type="submit" :value="$t('input.save')" v-on:click="addRegistration" class="button is-small is-primary" :disabled="!selectedAbsence">
                    </p>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'
import AbsenceSelect from '@/components/AbsenceSelect.vue'
import calendar from '@/utils/calendar'
import Datepicker from 'vuejs-datepicker'
import {en, da} from 'vuejs-datepicker/dist/locale'

export default {
  name: 'AbsenceRegistrations',
  components: {
      AbsenceSelect,
      Datepicker
  },
  data: function () {
      return {
        da: da,
        absence: '',
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        selectedAbsence: false,
        absenceMeasure: false,
        showTimeInfo: false,
        timeInfoIsClicked: false,
        allowEdit: false,
        time: 1
    }
  },
  firebase: function() { 
    const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
    const userid = JSON.parse(localStorage.getItem('profile')).user_id;
    return {
        absenceCodes: {
            source: firebase.database().ref('/organisations/' + tenantid + '/CausesOfAbsence'),
        },
        absenceNotSentForApproval: {
            source: firebase.database().ref('/organisations/' + tenantid + '/registrationsAbsence/' + userid).orderByChild('sentForApproval').equalTo(false),
        },
        dkHolidays: {
            source: firebase.database().ref('/holidays/dk/' + this.currentYear),
        },
        orgSettings: {
            source: firebase.database().ref('/organisations/' + tenantid + '/settings'),
            asObject: true,
        },
        workHours: {
            source: firebase.database().ref('/organisations/' + tenantid + '/userPreferences/' + userid + '/settings'),
            asObject: true
        },
    }
  },
  beforeCreate() {
    this.calendar = calendar
  },
  watch: {
      fromDate() {
          this.time = this.calendar.methods.noWorkingDays(this.workHours, this.dkHolidays, this.fromDate, this.toDate);
      },
      toDate() {
          this.time = this.calendar.methods.noWorkingDays(this.workHours, this.dkHolidays, this.fromDate, this.toDate);
      }
  },
  computed: {
    currentYear() {
        return moment().year()
    },  
    totalTime: function() {
      Array.prototype.sum = function (prop) {
          var total = 0
          for ( var i = 0, _len = this.length; i < _len; i++ ) {
              total += this[i][prop]
          }
          return total
      }
      return this.absenceNotSentForApproval.sum("time");
    }
  },
  methods: {
    setAbsence: function (absenceCode) {
        if(!absenceCode) {
            this.selectedAbsence = null
            this.absenceMeasure = null
        } else {
            this.selectedAbsence = absenceCode.code;
            this.absenceMeasure = absenceCode.measure;
        }
    },
    addRegistration: function() {
        const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
        const userid = JSON.parse(localStorage.getItem('profile')).user_id;
        const reg = {
          absence: this.selectedAbsence,
          absenceMeasure: this.absenceMeasure,
          isApproved: false,
          uid: userid,
          tenantid: tenantid,
          fromDate: moment(this.fromDate).format('YYYY-MM-DD'),
          toDate: moment(this.toDate).format('YYYY-MM-DD'),
          time: this.time,
          sentForApproval: false,
          timestamp: moment().format()
        }
        if(this.orgSettings.ERPenabled == false) {
          reg.isCustomProject = true
        }
        this.$firebaseRefs.absenceNotSentForApproval.push(reg)
        this.absence = '';
        this.fromDate = moment().format('YYYY-MM-DD')
        this.toDate = moment().format('YYYY-MM-DD')
        this.time = 0;
    },
    removeRegistration: function(registration) {
        this.$firebaseRefs.absenceNotSentForApproval.child(registration['.key']).remove()
    },
    sendAbsenceForApproval: function(registrations) {
      // for each registration push an approval in firebase
      var updates = {};
      for (var i = 0, len = registrations.length; i < len; ++i) {
          // add update information to array
          updates[registrations[i]['.key'] + '/sentForApproval'] = true;
      };
      try {  
        this.$firebaseRefs.absenceNotSentForApproval.update(updates)
      } catch(error) {
          this.error = error
      } finally {
            if(!this.error) {
                this.$snotify.success('Sendt til godkendelse', {
                    showProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true
                });
            }
      }
    }
  }
}
</script>
<style scoped>
.absence-input {
    width: 100px;
}
</style>

